<template>
  <aside 
    :class="[
      'fixed inset-y-0 left-0 z-50 w-64 transform transition-all duration-300 ease-out',
      'bg-white border-r border-gray-100',
      'flex flex-col',
      isOpen ? 'translate-x-0' : '-translate-x-full',
      'lg:translate-x-0 lg:static'
    ]"
  >
    <!-- Logo -->
    <div class="relative flex items-center justify-center px-8 py-10 mb-2">
      <div class="absolute bottom-4 left-1/2 -translate-x-1/2 w-12 h-1 rounded-full bg-gradient-to-r from-secondary-600 to-primary-700" style="background: linear-gradient(90deg, #5f4842 0%, #EDD97A 100%);"></div>
      <img src="/logos/logo4.png" alt="Logo" class="w-48 h-auto object-contain">
    </div>

    <!-- Navigation -->
    <nav class="flex-1 px-3 space-y-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-200 scrollbar-track-transparent">
      <router-link
        v-for="(item, index) in menuItems"
        :key="item.name"
        :to="item.path"
        :class="[
          'group flex items-center gap-3 px-4 py-3.5 rounded-lg text-[15px] font-medium transition-all duration-200 cursor-pointer relative menu-item-enter',
          currentView === item.id
            ? 'text-white shadow-sm'
            : 'text-gray-700 hover:bg-gray-50'
        ]"
        :style="[
          currentView === item.id ? 'background-color: #EDD97A;' : '',
          `animation-delay: ${index * 50}ms;`
        ]"
      >
        <!-- Indicador activo -->
        <div 
          v-if="currentView === item.id" 
          class="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 rounded-r-full" 
          style="background-color: #c9a94f;"
        ></div>
        
        <svg 
          :class="[
            'w-5 h-5 transition-transform duration-200',
            currentView === item.id ? '' : 'group-hover:scale-110'
          ]" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="item.icon" />
        </svg>
        <span class="flex-1">{{ item.name }}</span>
        <span v-if="item.badge" class="px-2 py-0.5 text-xs font-bold rounded-md text-white shadow-sm" style="background: linear-gradient(135deg, #5f4842 0%, #EDD97A 100%);">
          {{ item.badge }}
        </span>
      </router-link>
    </nav>

    <!-- User Profile -->
    <div class="p-3 border-t mt-auto" style="border-color: rgba(95, 72, 66, 0.15);">
      <div class="relative flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-gray-50 cursor-pointer transition-all duration-200 group overflow-hidden">
        <!-- Hover effect sutil con gradiente -->
        <div class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" style="background: linear-gradient(90deg, rgba(95, 72, 66, 0.03) 0%, rgba(19, 117, 71, 0.03) 100%);"></div>
        
        <div class="relative flex-shrink-0">
          <div class="w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold text-sm shadow-md ring-2 ring-white" style="background: linear-gradient(135deg, #5f4842 0%, #EDD97A 100%);">
            AD
          </div>
          <div class="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-white animate-pulse" style="background-color: #10b981;"></div>
        </div>
        <div class="relative flex-1 min-w-0">
          <p class="text-sm font-semibold text-gray-900 truncate">Admin User</p>
          <p class="text-xs truncate" style="color: #5f4842;">admin@shop.com</p>
        </div>
      </div>
    </div>
  </aside>
</template>

<script setup lang="ts">
interface MenuItem {
  id: string
  name: string
  icon: string
  path: string
  badge?: string
}

defineProps<{
  isOpen: boolean
  currentView: string
  menuItems: MenuItem[]
}>()
</script>

<style scoped>
/* Menu item entrance animation */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.menu-item-enter {
  animation: slideIn 0.4s ease-out forwards;
  opacity: 0;
}

/* Custom scrollbar */
.scrollbar-thin::-webkit-scrollbar {
  width: 4px;
}

.scrollbar-thin::-webkit-scrollbar-track {
  background: transparent;
}

.scrollbar-thin::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 20px;
}

.scrollbar-thin::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.2);
}
</style>

